export default "__VITE_ASSET__UmJ0mzDi__"